export function PulseErrorFallback() {
  return (
    <div className="min-h-screen bg-theme-bg flex items-center justify-center p-6">
      <div className="max-w-md rounded-2xl border border-theme-border bg-theme-panel p-8 text-center shadow-2xl">
        <h1 className="text-2xl font-black text-theme-text mb-3">Something went wrong</h1>
        <p className="text-sm text-theme-text-muted mb-6">
          An unexpected Pulse error occurred. The issue has been recorded.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg bg-theme-cta px-5 py-3 font-bold text-theme-cta-text transition-colors hover:bg-theme-cta-hover"
        >
          Reload Pulse
        </button>
      </div>
    </div>
  )
}
